const popupData = window.popupBundleData || {};

const checkIcon = popupData.checkIcon;

const addIcon = popupData.addIcon;

const openBtn = document.getElementById("openPopup");
const modal = document.getElementById("myPopup");
const closeBtn = document.querySelector(".close-btn");

// =========================================
// REWARD TYPE
// =========================================

const rewardType = (
  document.querySelector("#myPopup")?.dataset
    .popupRewardType || ""
)
  .trim()
  .toLowerCase();

// =========================================
  // IOS SAFARI SCROLL LOCK
//========================================= 

let scrollPosition = 0;

// =========================================
  // LAST VARIANT STATE (popup close thakleo mone rakhbe)
//=========================================

let lastVariantDetail = null;

let syncCurrentCardFromPDP = null;

// =========================================
  // SAFE DOM ACCESS
//========================================= 

function getPopupItems() {
  return document.querySelectorAll("[data-popup-item]");
}

function getUI() {
  return {
    totalPriceEl: document.querySelector("[data-popup-total-price]"),
    totalCountEl: document.querySelector("[data-popup-count]"),
    popupInputs: document.querySelector("[data-popup-inputs]"),
    addCartBtn: document.querySelector(".add-cart-btn"),
    comparePriceEl: document.querySelector(
      "[data-popup-compare-price]"
    ),
  };
}

// =========================================
   //CLOSE POPUP
//========================================= 

function closePopup() {
  if (!modal) return;

  modal.style.display = "none";

  document.body.classList.remove("popup-open");
  document.documentElement.classList.remove("popup-open");

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";

  window.scrollTo(0, scrollPosition);
}

// =========================================
  // FORMAT MONEY
//========================================= 

function formatMoney(cents) {
  const value = Math.round(Number(cents || 0) / 100) * 100;

  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney ===
      "function"
  ) {
    try {
      const format =
        (window.theme &&
          window.theme.moneyFormat) ||
        window.Shopify.money_format ||
        "{{amount_no_decimals}}";

      let formatted =
        Shopify.formatMoney(
          value,
          format
        );

      return formatted.replace(
        /Rs\.?\s*/gi,
        "₹"
      );

    } catch (e) {}
  }

  return "₹" + Math.round(value / 100);
}

//=========================================
   //PARSE VARIANT
//========================================= 

function parseVariantId(raw) {
  if (!raw) return 0;

  const str = String(raw).trim();

  return str.includes("/")
    ? Number(str.split("/").pop())
    : Number(str);
}

// =========================================
   //SELECTED ITEMS
//========================================= 

function getSelectedItems() {
  return Array.from(
    getPopupItems()
  ).filter((item) =>
    item.classList.contains("active")
  );
}

// The current product has no toggle checkbox (it's the
// product already being bought via the PDP's own Add to
// Cart) but still counts as an already-selected item — for
// the BOGO lowest-price calc, the footer total/count, AND
// the actual cart-add payload, so all three stay consistent
// with each other.
function getSelectedItemsWithCurrentProduct() {

  const selected = getSelectedItems();

  const currentProductCard = getPopupItems()[0];

  if (
    currentProductCard &&
    currentProductCard.dataset.isCurrentProduct === "true" &&
    selected.indexOf(currentProductCard) === -1
  ) {
    return [currentProductCard, ...selected];
  }

  return selected;
}

// =========================================
   //AMOUNT DISCOUNT
// =========================================

function calcTotalForAmount(
  selected
) {
  if (!selected.length) return 0;

  let hasCombo = false;
  let hasNonCombo = false;

  let comboTotalPaise = 0;
  let nonComboTotalPaise = 0;

  selected.forEach((item) => {

    const type = (
      item.dataset.productType || ""
    )
      .trim()
      .toLowerCase();

    const price = Number(
      item.dataset.price || 0
    );

    if (type === "combo") {

      hasCombo = true;
      comboTotalPaise += price;

    } else {

      hasNonCombo = true;
      nonComboTotalPaise += price;
    }
  });

  const totalRupees =
    (comboTotalPaise +
      nonComboTotalPaise) /
    100;

  let comboDiscount = 0;
  let nonComboDiscount = 0;

  if (hasCombo && hasNonCombo) {

    comboDiscount = 25;

    nonComboDiscount =
      totalRupees >= 999
        ? 20
        : 15;

  } else if (hasCombo) {

    comboDiscount = 25;

  } else if (hasNonCombo) {

    nonComboDiscount =
      totalRupees >= 999
        ? 20
        : 15;
  }

  const comboRupees =
    comboTotalPaise / 100;

  const nonComboRupees =
    nonComboTotalPaise / 100;

  const comboFinal =
    comboDiscount
      ? Math.round(
          comboRupees *
            (1 -
              comboDiscount / 100)
        )
      : comboRupees;

  const nonComboFinal =
    nonComboDiscount
      ? Math.round(
          nonComboRupees *
            (1 -
              nonComboDiscount /
                100)
        )
      : nonComboRupees;

  return Math.round(
    (comboFinal +
      nonComboFinal) *
      100
  );
}

// =========================================
   //BOGO
// =========================================

function calcTotalForBogo(selected) {
  if (!selected.length) return 0;

  const flat = [];

  selected.forEach((item) => {

    const price =
      Number(
        item.dataset.price || 0
      ) / 100;

    const type = (
      item.dataset.productType || ""
    )
      .trim()
      .toLowerCase();

    flat.push({
      price,
      isCombo:
        type.indexOf("combo") !==
        -1,
    });
  });

  const normal = flat.filter(
    (i) => !i.isCombo
  );

  const combo = flat.filter(
    (i) => i.isCombo
  );

  function applyBogo(
    items,
    maxFree
  ) {

    const sorted = items
      .slice()
      .sort(
        (a, b) =>
          a.price - b.price
      );

    const freeCount = Math.min(
      maxFree,
      Math.floor(
        sorted.length / 2
      )
    );

    return sorted.reduce(
      (sum, item, idx) =>
        sum +
        (idx < freeCount
          ? 1
          : item.price),
      0
    );
  }

  const totalRupees =
    applyBogo(normal, 4) +
    applyBogo(combo, 1);

  return Math.round(
    totalRupees * 100
  );
}

// =========================================
   //PRODUCT TIER PRICING
// =========================================

// Delegates to window.DnkPricing.calcBundleTotal() — the same IP Sale tier
// engine registered by cart-mode-ip-sale.js and already used by
// customers-also-bought.js. Pure calculation over the selected items, no
// network calls needed (window.DotKeyIpSale, used here previously, is never
// defined anywhere in the theme — this popup's tier pricing was silently
// falling back to a flat sum before this fix).
function selectedToPricingItems(
  selected
) {
  return selected.map((item) => ({
    variantId: parseVariantId(
      item.dataset.variantId
    ),
    price: Number(
      item.dataset.price || 0
    ),
    productType:
      item.dataset.productType ||
      "",
    // IP Sale-only exclusion (cart_mode_price_set_for_ip metaobject) —
    // rendered as data-excluded by pdp-boost-results.liquid. Without this,
    // a product excluded only via that merchant-configured list (not the
    // two hardcoded variant IDs calcBundleTotal already knows about) would
    // get wrongly bundled into the lip/tier math when selected here.
    excluded: item.dataset.excluded === "true",
  }));
}

function getProductTierPrice(
  selected
) {

  if (!selected.length) return 0;

  const pricing =
    window.DnkPricing;

  if (
    !pricing ||
    typeof pricing.calcBundleTotal !==
      "function"
  ) {
    return selected.reduce(
      (sum, item) =>
        sum +
        Number(
          item.dataset.price || 0
        ),
      0
    );
  }

  return pricing.calcBundleTotal(
    selectedToPricingItems(selected)
  );
}

// =========================================
   //BOOST RESULT — LOWEST-PRICED SELECTED PRODUCT AT ₹1 (BOGO DISPLAY ONLY)
// =========================================

const BOGO_LOWEST_PRICE_PAISE = 100;

const BOGO_FREE_ICON_URL =
  "https://cdn.shopify.com/s/files/1/0361/8553/8692/files/icon-free.png?v=1732515817";

function setBoostFreeBadge(item, show) {

  const imgBox = item.querySelector(".img-box");

  if (!imgBox) return;

  const existingBadge = imgBox.querySelector(
    ".boost-icon-free"
  );

  if (show) {

    if (!existingBadge) {

      const badge = document.createElement("img");

      badge.src = BOGO_FREE_ICON_URL;
      badge.alt = "Free item";
      badge.loading = "lazy";
      badge.className = "boost-icon-free";

      imgBox.insertBefore(badge, imgBox.firstChild);
    }

  } else if (existingBadge) {

    existingBadge.remove();
  }
}

function getCardPriceEls(item) {
  return {
    priceWrap: item.querySelector(".popup-price-wrap"),
    saleEl: item.querySelector(".sale-price"),
    compareEl: item.querySelector(".compare-price"),
  };
}

function renderNaturalCardPrice(item) {

  const { priceWrap, saleEl, compareEl } =
    getCardPriceEls(item);

  if (!priceWrap || !saleEl) return;

  const salePrice = Number(item.dataset.price || 0);
  const comparePrice = Number(
    item.dataset.compareAtPrice || 0
  );

  saleEl.textContent = formatMoney(salePrice);

  if (comparePrice > salePrice) {

    if (compareEl) {

      compareEl.hidden = false;
      compareEl.textContent = formatMoney(comparePrice);

    } else {

      const s = document.createElement("s");

      s.className = "compare-price";
      s.textContent = formatMoney(comparePrice);

      priceWrap.insertBefore(s, saleEl);
    }

  } else if (compareEl) {

    compareEl.hidden = true;
    compareEl.textContent = "";
  }

  setBoostFreeBadge(item, false);
}

function applyBogoLowestCardPrice(item) {

  const { priceWrap, saleEl } = getCardPriceEls(item);

  if (!priceWrap || !saleEl) return;

  const salePrice = Number(item.dataset.price || 0);
  const comparePrice = Number(
    item.dataset.compareAtPrice || 0
  );

  const originalMrp =
    comparePrice > salePrice
      ? comparePrice
      : salePrice;

  let compareEl =
    getCardPriceEls(item).compareEl;

  if (!compareEl) {

    compareEl = document.createElement("s");
    compareEl.className = "compare-price";
  }

  compareEl.hidden = false;
  compareEl.textContent = formatMoney(originalMrp);

  saleEl.textContent = formatMoney(
    BOGO_LOWEST_PRICE_PAISE
  );

  // BOGO layout: ₹1 sale price on the left, original price
  // (strikethrough) on the right.
  if (saleEl.nextSibling !== compareEl) {
    priceWrap.insertBefore(compareEl, saleEl.nextSibling);
  }

  setBoostFreeBadge(item, true);
}

// Boost Result specific: the lowest-priced product(s) among
// the eligible items show at ₹1 when BOGO mode is on. The
// caller (syncPopupState) passes `selected` which already
// includes the current product card (it has no toggle button
// but still always counts as already-selected) plus whatever
// related items are checked. Normally just the single
// cheapest eligible item qualifies; once 4 or more items are
// eligible, the 2 cheapest both qualify. Recomputed on every
// selection change. Doesn't touch dataset.price, so
// calcTotalForBogo and the cart payload keep reading the real
// price untouched.
const BOGO_MULTI_FREE_MIN_SELECTED = 4;
const BOGO_MULTI_FREE_COUNT = 2;

// BOGO needs at least a pair — with a single selected product there is
// nothing to give free, so the card shows its natural price (no ₹1, no
// strike-through, no Free badge).
const BOGO_MIN_ELIGIBLE_FOR_FREE = 2;

function refreshBoostBogoPricing(selectedItems) {

  if (rewardType !== "bogo") return;

  const allItems = Array.from(getPopupItems());

  const eligibleItems = selectedItems || [];

  const freeCount = eligibleItems.length >= BOGO_MIN_ELIGIBLE_FOR_FREE
    ? eligibleItems.length >= BOGO_MULTI_FREE_MIN_SELECTED
      ? BOGO_MULTI_FREE_COUNT
      : 1
    : 0;

  const lowestItems = new Set(
    freeCount
      ? eligibleItems
          .slice()
          .sort(
            (a, b) =>
              Number(a.dataset.price || 0) -
              Number(b.dataset.price || 0)
          )
          .slice(0, freeCount)
      : []
  );

  allItems.forEach((item) => {

    renderNaturalCardPrice(item);

    if (lowestItems.has(item)) {
      applyBogoLowestCardPrice(item);
    }
  });
}

// =========================================
   //MAIN SYNC ENGINE
// =========================================

async function syncPopupState() {

  const ui = getUI();

let selected =
  getSelectedItems();

// =========================================
   //MINIMUM 1 PRODUCT ALWAYS
// =========================================

if (selected.length === 0) {

  const firstItem =
    getPopupItems()[0];

  if (firstItem) {

    selected = [firstItem];

    firstItem.classList.add(
      "active"
    );

    const btn =
      firstItem.querySelector(
        ".toggle-btn"
      );

    if (btn) {

      btn.className =
        "checkicon toggle-btn";

      btn.innerHTML = `
        <img
          src="${checkIcon}"
          alt=""
          class="toggle-icon"
        >
      `;
    }
  }
}

// =========================================
   //CURRENT PRODUCT ALWAYS INCLUDED
// =========================================

selected = getSelectedItemsWithCurrentProduct();

refreshBoostBogoPricing(selected);

const count = selected.length;

 //let total = 0; 


  // =========================
   //TOTAL LOGIC
//========================= //

const isFallbackSingle =
  selected.length === 1 &&
  selected[0] === getPopupItems()[0];

if (isFallbackSingle) {

  total = Number(
    selected[0].dataset.price || 0
  );

} else if (
  rewardType === "amount"
) {

  total =
    calcTotalForAmount(
      selected
    );

} else if (
  rewardType === "bogo"
) {

  total =
    calcTotalForBogo(
      selected
    );

} else if (
  rewardType === "product"
) {

  // =========================================
     //NORMAL SALE TOTAL
  // =========================================

  const normalSaleTotal =
    selected.reduce(
      (sum, item) =>
        sum +
        Number(
          item.dataset.price || 0
        ),
      0
    );

  // =========================================
     //TIERED TOTAL (window.DnkPricing — same IP Sale engine as the cart)
  // =========================================

  const tierTotal =
    getProductTierPrice(
      selected
    );

  /*
    direct tier apply hole
    example:
    2 item = 699
    3 item = 999
  */

  total =
    tierTotal > 0 &&
    tierTotal < normalSaleTotal
      ? tierTotal
      : normalSaleTotal;

} else {

  total = selected.reduce(
    (sum, item) =>
      sum +
      Number(
        item.dataset.price || 0
      ),
    0
  );
}
 

// =========================
   //STRIKE TOTAL
//========================= //

let compareTotal = 0;

let hasDiscount = false;

selected.forEach((item) => {

  const comparePrice =
    Number(
      item.dataset.compareAtPrice || 0
    );

  const salePrice =
    Number(
      item.dataset.price || 0
    );

  // offer detect 
  if (
    comparePrice > salePrice
  ) {

    hasDiscount = true;
  }

  // strike total always sale price sum //
compareTotal += comparePrice > 0 ? comparePrice : salePrice;
});

// =========================================
   //TOTAL SAFETY
// =========================================

// total always sale price based //
if (
  !total ||
  total <= 0
) {

  total = selected.reduce(
    (sum, item) => {

      return (
        sum +
        Number(
          item.dataset.price || 0
        )
      );

    },
    0
  );
}

// =========================
  //FORM INPUTS
//========================= 

if (ui.popupInputs) {

  ui.popupInputs.innerHTML =
    "";
}

selected.forEach(
  (item, index) => {

    const variantId =
      parseVariantId(
        item.dataset.variantId
      );

    if (!variantId) return;

    ui.popupInputs.insertAdjacentHTML(
      "beforeend",
      `
      <input
        type="hidden"
        name="items[${index}][id]"
        value="${variantId}"
      >

      <input
        type="hidden"
        name="items[${index}][quantity]"
        value="1"
      >
      `
    );
  }
);

// =========================
   //UI UPDATE
//========================= 

requestAnimationFrame(() => {

  // =========================================
    // COMPARE PRICE UI
  // =========================================

 if (ui.comparePriceEl) {

  if (compareTotal > total) {

    ui.comparePriceEl.hidden = false;

    ui.comparePriceEl.textContent =
      formatMoney(compareTotal);

  } else {

    ui.comparePriceEl.hidden = true;

    ui.comparePriceEl.textContent = "";
  }
}
  // =========================================
     //TOTAL PRICE UI
  // =========================================

  if (ui.totalPriceEl) {

    ui.totalPriceEl.textContent =
      formatMoney(total);
  }

  // =========================================
     //COUNT UI
  // =========================================

  if (ui.totalCountEl) {

    ui.totalCountEl.textContent =
      `(${count})`;
  }

  // =========================================
     //BUTTON STATE
  // =========================================

  if (ui.addCartBtn) {

    ui.addCartBtn.disabled =
      count === 0;
  }
});
}

// =========================================
   //RESET POPUP
// =========================================

function resetPopupSelections() {

  getPopupItems().forEach(
    (item, index) => {

      const btn =
        item.querySelector(
          ".toggle-btn"
        );

      if (index > 0) {

        item.classList.add(
          "active"
        );

        if (btn) {

          btn.className =
            "checkicon toggle-btn";

          btn.innerHTML = `
            <img
              src="${checkIcon}"
              alt=""
              class="toggle-icon"
            >
          `;
        }

      } else {

        item.classList.remove(
          "active"
        );

        if (btn) {

          btn.className =
            "add toggle-btn";

          btn.innerHTML = `
            <img
              src="${addIcon}"
              alt=""
              class="toggle-icon add"
            >
          `;
        }
      }
    }
  );

  setTimeout(() => {
    syncPopupState();
  }, 0);
}

// =========================================
   //INIT EVENTS
// =========================================

let initialized = false;

function initToggleEvents() {

  if (initialized) return;

  initialized = true;

  getPopupItems().forEach(
    (item) => {

      const btn =
        item.querySelector(
          ".toggle-btn"
        );

      if (!btn) return;

      btn.addEventListener(
        "click",
        (e) => {

          e.stopPropagation();

          item.classList.toggle(
            "active"
          );

          if (
            item.classList.contains(
              "active"
            )
          ) {

            btn.className =
              "checkicon toggle-btn";

            btn.innerHTML = `
              <img
                src="${checkIcon}"
                alt=""
                class="toggle-icon"
              >
            `;

          } else {

            btn.className =
              "add toggle-btn";

            btn.innerHTML = `
              <img
                src="${addIcon}"
                alt=""
                class="toggle-icon add"
              >
            `;
          }

          requestAnimationFrame(
            () => {
              requestAnimationFrame(
                () => {
                  syncPopupState();
                }
              );
            }
          );
        }
      );
    }
  );
}

// =========================================
   //OPEN POPUP
// =========================================

if (openBtn) {

  openBtn.onclick = (e) => {

    e.stopPropagation();

    modal.style.display =
      "block";

    document.body.classList.add(
      "popup-open"
    );

    document.documentElement.classList.add(
      "popup-open"
    );

    scrollPosition =
      window.pageYOffset;

    document.body.style.position =
      "fixed";

    document.body.style.top =
      `-${scrollPosition}px`;

    document.body.style.width =
      "100%";

    resetPopupSelections();

    // =========================================
      // OPEN HOLEI PDP VARIANT ER SATHE SYNC
    // =========================================

    if (typeof syncCurrentCardFromPDP === "function") {
      syncCurrentCardFromPDP();
    }

    setTimeout(() => {

      requestAnimationFrame(
        () => {
          syncPopupState();
        }
      );

    }, 50);
  };
}

// =========================================
   //CLOSE POPUP
// =========================================

if (closeBtn) {
  closeBtn.onclick = closePopup;
}

document.addEventListener(
  "click",
  () => {

    if (
      modal &&
      modal.style.display ===
        "block"
    ) {
      closePopup();
    }
  }
);

if (modal) {

  modal.addEventListener(
    "click",
    (e) => {
      e.stopPropagation();
    }
  );
}

// =========================================
   //ADD TO CART
// =========================================

async function addSelectedToCart() {

  const selected =
    getSelectedItemsWithCurrentProduct();

  if (!selected.length) return;

  const itemsPayload =
    selected
      .map((item) => ({
        id: parseVariantId(
          item.dataset.variantId
        ),
        quantity: 1,
      }))
      .filter(
        (i) => i.id > 0
      );

  const ui = getUI();

  const originalHTML =
    ui.addCartBtn.innerHTML;

  ui.addCartBtn.disabled =
    true;

  ui.addCartBtn.innerHTML =
    "ADDING...";

  try {

    const res = await fetch(
      "/cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
          Accept:
            "application/json",
        },
        body: JSON.stringify({
          items: itemsPayload,
        }),
      }
    );

    if (!res.ok) {
      throw new Error(
        "Cart failed"
      );
    }

    const cartDrawer =
      document.querySelector(
        "cart-drawer"
      );

    if (cartDrawer) {

      const sectionsRes =
        await fetch(
          "/?sections=cart-drawer,cart-icon-bubble"
        );

      if (sectionsRes.ok) {

        const data =
          await sectionsRes.json();

        if (
          typeof cartDrawer.renderContentsCustom ===
          "function"
        ) {

          cartDrawer.renderContentsCustom(
            data,
            true
          );

        } else if (
          typeof cartDrawer.renderContents ===
          "function"
        ) {

          cartDrawer.renderContents({
            sections: data,
          });

          if (
            typeof cartDrawer.open ===
            "function"
          ) {
            cartDrawer.open();
          }
        }

        // Rendering the drawer directly bypasses the
        // PUB_SUB_EVENTS.cartAdd flow. The active cart-mode script
        // (cart-mode-bau.js / cart-mode-ip-sale.js) recomputes each
        // cart line's discounted price and compare-at strikethrough on
        // cartUpdate — without this publish the drawer shows raw
        // undiscounted prices. Mirrors customers-also-bought.js and
        // searchtap-collection.js.
        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "boost-result-popup",
          });
        }
      }
    }

    ui.addCartBtn.innerHTML =
      "ADDED ✓";

    closePopup();

    resetPopupSelections();

    syncPopupState();

    setTimeout(() => {

      ui.addCartBtn.innerHTML =
        originalHTML;

      ui.addCartBtn.disabled =
        false;

    }, 300);

  } catch (e) {

    console.error(e);

    ui.addCartBtn.innerHTML =
      "ERROR";

    setTimeout(() => {

      ui.addCartBtn.innerHTML =
        originalHTML;

      ui.addCartBtn.disabled =
        false;

      syncPopupState();

    }, 1200);
  }
}

// =========================================
   //FORM SUBMIT
// =========================================

const popupForm =
  document.querySelector(
    "[data-popup-form]"
  );

if (popupForm) {

  popupForm.addEventListener(
    "submit",
    (e) => {

      e.preventDefault();

      addSelectedToCart();
    }
  );
}


// =========================================
   //VARIANT PRICE FIX (customers-also-bought pattern)
// =========================================

const currentProductCard = document.querySelector(
  '[data-is-current-product="true"]'
);

if (currentProductCard) {

  function updateCurrentProductCard({
    variantId,
    price,
    compareAtPrice,
    imageSrc,
  }) {

    // =========================================
      // DATA UPDATE
    // =========================================

    currentProductCard.dataset.variantId = variantId;
    currentProductCard.dataset.price = price;
    currentProductCard.dataset.compareAtPrice =
      compareAtPrice || price;

    // =========================================
       //SALE PRICE UPDATE
    // =========================================

    const priceEl =
      currentProductCard.querySelector(
        "[data-current-product-price]"
      ) ||
      currentProductCard.querySelector(".sale-price");

    if (priceEl) {
      priceEl.textContent = formatMoney(price);
    }

    // =========================================
      // COMPARE PRICE UPDATE
    // =========================================

    const comparePriceEl =
      currentProductCard.querySelector(".compare-price");

    if (comparePriceEl) {

      if (
        compareAtPrice &&
        Number(compareAtPrice) > Number(price)
      ) {
        comparePriceEl.style.display = "";
        comparePriceEl.textContent =
          formatMoney(compareAtPrice);
      } else {
        comparePriceEl.style.display = "none";
        comparePriceEl.textContent = "";
      }
    }

    // =========================================
      // IMAGE UPDATE
    // =========================================

    if (imageSrc) {

      const img =
        currentProductCard.querySelector(
          ".img-box img:not(.boost-icon-free)"
        );

      if (img) {
        img.src = imageSrc;
        img.srcset = imageSrc;

        img
          .closest("picture")
          ?.querySelectorAll("source")
          .forEach((s) => {
            s.srcset = imageSrc;
          });
      }
    }

    // =========================================
      // SWATCH is-selected SYNC
    // =========================================

    const swatchBtns =
      currentProductCard.querySelectorAll(".color_buttons_bb");

    if (swatchBtns.length) {

      const targetId = parseVariantId(variantId);

      swatchBtns.forEach((btn) => {

        const match =
          parseVariantId(btn.dataset.variantId) === targetId;

        btn.classList.toggle("is-selected", match);
      });

      // =========================================
        // SHADE NAME UPDATE
      // =========================================

      const shadeName =
        currentProductCard.querySelector(
          ".selected-color-name"
        );

      if (shadeName) {

        const selectedBtn =
          currentProductCard.querySelector(
            ".color_buttons_bb.is-selected"
          );

        if (selectedBtn) {
          shadeName.textContent =
            selectedBtn.dataset.title || "";
        }
      }
    }

    // =========================================
       //POPUP TOTAL RE-CALCULATE
    // =========================================

    syncPopupState();
  }

  // =========================================
    // CUSTOM EVENT (npdp-details.js)
  // =========================================

  document.addEventListener(
    "dnk:pdp:variant-change",
    function (event) {

      if (!event || !event.detail) return;

      const detail = event.detail;

      // matching swatch theke image lookup
      // (detail e image na thakleo kaj korbe)
      const matchingBtn = Array.from(
        currentProductCard.querySelectorAll(
          ".color_buttons_bb"
        )
      ).find(
        (btn) =>
          parseVariantId(btn.dataset.variantId) ===
          parseVariantId(detail.variantId)
      );

      lastVariantDetail = {
        variantId: detail.variantId,
        price: detail.price,
        compareAtPrice: detail.compareAtPrice || 0,
        imageSrc:
          detail.imageSrc ||
          detail.image ||
          (matchingBtn
            ? matchingBtn.dataset.image || null
            : null),
      };

      updateCurrentProductCard(lastVariantDetail);
    }
  );

  // =========================================
    // PUBSUB FALLBACK (theme variantChange)
  // =========================================

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {

    const cardProductId =
      currentProductCard.dataset.productId;

    subscribe(
      PUB_SUB_EVENTS.variantChange,
      (data) => {

        if (
          String(data.productId) !==
          String(cardProductId)
        ) {
          return;
        }

        const variant = data.variant;

        if (!variant) return;

        const matchingBtn =
          currentProductCard.querySelector(
            `.color_buttons_bb[data-variant-id="${variant.id}"]`
          );

        lastVariantDetail = {
          variantId: variant.id,
          price: variant.price,
          compareAtPrice:
            variant.compare_at_price || 0,
          imageSrc: matchingBtn
            ? matchingBtn.dataset.image || null
            : null,
        };

        updateCurrentProductCard(lastVariantDetail);
      }
    );
  }

  // =========================================
    // POPUP OPEN SYNC FUNCTION
    // (event miss holeo PDP form theke current variant tule anbe)
  // =========================================

  syncCurrentCardFromPDP = function () {

    // 1) age event theke store kora detail thakle seta apply
    if (lastVariantDetail) {
      updateCurrentProductCard(lastVariantDetail);
      return;
    }

    // 2) fallback: PDP form er current variant id read koro
    //    (popup er nijer form bad diye)
    const pdpVariantInput = document.querySelector(
      'form[action*="/cart/add"]:not([data-popup-form]) [name="id"]'
    );

    const vid = parseVariantId(
      pdpVariantInput && pdpVariantInput.value
    );

    if (!vid) return;

    // card e already same variant thakle kichu korar dorkar nei
    if (
      parseVariantId(
        currentProductCard.dataset.variantId
      ) === vid
    ) {
      return;
    }

    // matching swatch theke price/compare/image tule ano
    const matchingBtn = Array.from(
      currentProductCard.querySelectorAll(
        ".color_buttons_bb"
      )
    ).find(
      (btn) =>
        parseVariantId(btn.dataset.variantId) === vid
    );

    if (!matchingBtn) return;

    updateCurrentProductCard({
      variantId: vid,
      price: matchingBtn.dataset.price,
      compareAtPrice:
        matchingBtn.dataset.compareAtPrice || 0,
      imageSrc:
        matchingBtn.dataset.image || null,
    });
  };
}



// =========================================
  //INIT
// =========================================

initToggleEvents();

resetPopupSelections();

// =========================================
   //SWATCH VARIANT SWITCH
// =========================================

document.querySelectorAll('.color_buttons_bb').forEach(btn => {

  btn.addEventListener('click', function() {

    const card = this.closest('.popup-product-card');

    if (!card) return;

   card.querySelectorAll('.color_buttons_bb')
      .forEach(el => el.classList.remove('is-selected'));

    this.classList.add('is-selected');

    card.dataset.variantId =
      this.dataset.variantId;

    card.dataset.price =
      this.dataset.price;

    card.dataset.compareAtPrice =
      this.dataset.compareAtPrice ||
      this.dataset.price;

   
    const shadeName =
      card.querySelector('.selected-color-name');

    if (shadeName) {

      shadeName.textContent =
        this.dataset.title;
    }

   
    const img =
      card.querySelector(
        '.img-box img:not(.boost-icon-free)'
      );

    if (img && this.dataset.image) {

      img.src =
        this.dataset.image;

      img.srcset =
        this.dataset.image;
    }

   
    const salePrice =
      card.querySelector('.sale-price');

    if (salePrice) {

      salePrice.textContent =
        formatMoney(
          this.dataset.price
        );
    }

 
    
    const comparePrice =
      card.querySelector('.compare-price');

    if (comparePrice) {

      const cp = Number(
        this.dataset.compareAtPrice || 0
      );

      const sp = Number(
        this.dataset.price || 0
      );

      if (cp > sp) {

        comparePrice.style.display = '';

        comparePrice.textContent =
          formatMoney(cp);

      } else {

        comparePrice.style.display = 'none';
      }
    }

    syncPopupState();

  });

});

// =========================================
   //BOOST LABEL CONTROL
// =========================================

const boostLabel =
  document.querySelector(".boost-label");

const sliderWrapper =
  document.querySelector(".main-pdp__gallery");

const galleryTrack =
  document.querySelector("[data-pdp-gallery-track]");

if (boostLabel) {

  function showBoostLabel() {
    boostLabel.classList.remove("hide");
  }

  function hideBoostLabel() {
    boostLabel.classList.add("hide");
  }

  // =========================================
     //ACTIVE SLIDE INDEX DETECT
  // =========================================

  function getActiveSlideIndex() {

    // 1) active thumb theke (mobile thumbs)
    const activeThumb =
      document.querySelector(
        ".pdp-gallery-thumbs__btn--active[data-pdp-thumb]"
      );

    if (activeThumb) {
      return Number(
        activeThumb.dataset.pdpThumb || 0
      );
    }

    // 2) fallback: track transform theke
    if (galleryTrack) {

      const style =
        window.getComputedStyle(galleryTrack);

      if (
        style.transform &&
        style.transform !== "none"
      ) {

        const matrix =
          new DOMMatrixReadOnly(style.transform);

        const firstSlide =
          galleryTrack.querySelector(
            "[data-pdp-slide]"
          );

        const slideW =
          firstSlide
            ? firstSlide.offsetWidth
            : 0;

        if (slideW > 0) {
          return Math.round(
            Math.abs(matrix.m41) / slideW
          );
        }
      }
    }

    return 0;
  }

  function checkFirstSlide() {

    if (getActiveSlideIndex() === 0) {

      showBoostLabel();

    } else {

      hideBoostLabel();
    }
  }

  // =========================================
     //INITIAL
  // =========================================

  setTimeout(() => {

    boostLabel.classList.remove("hide");

    checkFirstSlide();

  }, 300);

  // =========================================
     //ARROW CLICK (prev/next buttons)
  // =========================================

  document.addEventListener(
    "pointerdown",
    function (e) {

      const arrow =
        e.target.closest(
          "[data-pdp-gallery-prev], [data-pdp-gallery-next]"
        );

      if (!arrow) return;

      hideBoostLabel();

      setTimeout(() => {
        checkFirstSlide();
      }, 400);
    }
  );

  // =========================================
     //THUMB CLICK (mobile thumbs)
  // =========================================

  document.addEventListener(
    "click",
    function (e) {

      const thumb =
        e.target.closest(
          ".pdp-gallery-thumbs [data-pdp-thumb]"
        );

      if (!thumb) return;

      const thumbIndex =
        Number(thumb.dataset.pdpThumb || 0);

      if (thumbIndex === 0) {

        showBoostLabel();

      } else {

        hideBoostLabel();
      }

      setTimeout(() => {
        checkFirstSlide();
      }, 250);
    }
  );

  // =========================================
     //DRAG / SWIPE
  // =========================================

  if (sliderWrapper) {

    sliderWrapper.addEventListener(
      "pointerdown",
      function () {
        hideBoostLabel();
      },
      { passive: true }
    );

    sliderWrapper.addEventListener(
      "pointerup",
      function () {

        setTimeout(() => {
          checkFirstSlide();
        }, 300);

      },
      { passive: true }
    );

    sliderWrapper.addEventListener(
      "touchend",
      function () {

        setTimeout(() => {
          checkFirstSlide();
        }, 300);

      },
      { passive: true }
    );

    sliderWrapper.addEventListener(
      "wheel",
      function () {

        hideBoostLabel();

        setTimeout(() => {
          checkFirstSlide();
        }, 300);

      },
      { passive: true }
    );
  }

  // =========================================
     //FIRST SCROLL COLLAPSE
  // =========================================

  window.addEventListener(
    "scroll",
    function () {

      if (!sliderWrapper || !boostLabel) return;

      const rect =
        sliderWrapper.getBoundingClientRect();

      if (window.innerWidth < 768) {

        if (rect.top <= 80) {
          hideBoostLabel();
        } else {
          checkFirstSlide();
        }

      } else {

        // Desktop
        if (rect.bottom <= 180) {
          hideBoostLabel();
        } else {
          checkFirstSlide();
        }

      }

    },
    { passive: true }
  );

  // =========================================
     //OBSERVER (thumb + slide class change)
  // =========================================

  const observer = new MutationObserver(() => {

    clearTimeout(window.boostObserverTimer);

    window.boostObserverTimer =
      setTimeout(() => {

        checkFirstSlide();

      }, 100);

  });

  document
    .querySelectorAll(
      ".pdp-gallery-thumbs__btn, .main-pdp__gallery-slide"
    )
    .forEach((el) => {

      observer.observe(el, {
        attributes: true,
        attributeFilter: ["class"]
      });

    });

  // slide change hole track er transform / style change hoy
  if (galleryTrack) {

    observer.observe(galleryTrack, {
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }

  // =========================================
     //SWIPER SUPPORT
  // =========================================

  document.addEventListener(
    "slideChange",
    function () {

      setTimeout(() => {

        checkFirstSlide();

      }, 150);

    }
  );
}
